import React, { useState } from "react";
import MultiSubitemEditor from "./MultiSubitemEditor";
import useToggle from "../../../hooks/useToggle";
import TabbedMultiSubitem from "./TabbedMultiSubitem";
import useModule from "../../../hooks/useModule";
import { Prefill } from "../../../types/GlobalInterfaces";
import { generatePrefill } from "../../../utils/QuickCreateUtils";
import StrUtils from "../../../utils/StrUtils";
import useUser from "../../../api/api-hooks/auth/useUser";
import { ReusableViewReferenceFields } from "../../../types/PageInterfaces";

interface Props {
  records: any[];
  fieldSchema: any;
  parentRecord: any;
  reusableViewReferenceFields?: ReusableViewReferenceFields;
}

const MultiSubitemTable = ({
  records,
  fieldSchema,
  parentRecord,
  reusableViewReferenceFields,
}: Props) => {
  const { getModule } = useModule(parentRecord._ModuleAPIName);
  const { user } = useUser();
  const [subitemAdding, setSubitemAdding] = useState(false);
  const [isDuplicating, toggleDuplicateSubitem] = useToggle(false);
  const [prefill, setPrefill] = useState(null);
  const module = getModule(parentRecord?._ModuleAPIName);

  return (
    <>
      {subitemAdding || isDuplicating ? (
        <div className="p-2">
          <MultiSubitemEditor
            isDuplicating={isDuplicating}
            toggleDuplicateSubitem={toggleDuplicateSubitem}
            //@ts-ignore
            module={module}
            parentRecord={parentRecord}
            fieldSchema={fieldSchema}
            prefill={prefill}
            setPrefill={setPrefill}
            currentValues={records}
            setSubitemAdding={setSubitemAdding}
            showCloseButton
            reusableViewReferenceFields={reusableViewReferenceFields}
          />
        </div>
      ) : (
        <div className="p-2">
          {/* @ts-ignore */}
          <TabbedMultiSubitem
            subitemDuplicating={isDuplicating}
            toggleDuplicateSubitem={toggleDuplicateSubitem}
            module={module}
            fieldSchema={fieldSchema}
            records={records}
            parentRecord={parentRecord}
            showTitle={false}
            setAddingSubitem={setSubitemAdding}
            subitemAdding={subitemAdding}
            managePrefill={managePrefill}
            reusableViewReferenceFields={reusableViewReferenceFields}
          />
        </div>
      )}
    </>
  );

  function managePrefill(value: Prefill) {
    const variableVals = {
      user: {
        id: user?.id,
        _RecordName: user?.Name,
        FirstName: StrUtils.getFirstName(user?.Name),
        LastName: StrUtils.getLastName(user?.Name),
        ModuleAPIName: "Contacts",
      },
    };
    const prefill = value?.PrefillPairs;
    generatePrefill(
      prefill,
      variableVals,
      fieldSchema.SubitemFields,
      setPrefill
    );
  }
};

export default MultiSubitemTable;
